// People with «Casteller» unticked who are not canalla, músics or novells
// fall outside every other attendance group, so they get one of their own.
export const isNoCasteller = c =>
    parseInt(c?.casteller) === 0 &&
    parseInt(c?.canalla) !== 1 &&
    parseInt(c?.music) !== 1 &&
    parseInt(c?.novell) !== 1
